var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('section',[_c('header',[_c('h2',[_vm._v("Сервер прислал пустые данные!")]),_vm._v(" "),_c('p',[_vm._v("по вашему запросу нет информации!")]),_vm._v(" "),_c('p',[_vm._v("введите корректные данные!")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b693679","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/emptyPayload.vue
// module id = null
// module chunks = 